// Holds back navigations until the data the next view reads is loaded.
// Only the latest navigation goes through: an older one that is still
// waiting is dropped and its loading overlay released.

/**
 * @param {object} deps
 * @param {(hash: string) => boolean} deps.needsData   true while the view can't open yet
 * @param {() => Promise<any>} deps.ensureData        loads the data of the current language
 * @param {() => () => void} deps.showLoading         shows loading feedback, returns hide
 * @returns {(hash: string, go: () => any, fail: (error: any) => any) => any}
 */
export function createDataGate ({ needsData, ensureData, showLoading }) {
  let latest = 0;
  let hideLoading = () => {};

  return function whenReady (hash, go, fail) {
    const navigation = ++latest;
    const isLatest = () => navigation == latest;

    hideLoading();
    if (!needsData(hash)) return go();

    const hide = hideLoading = showLoading();
    // The language may change while loading: load again until it's ready
    const untilReady = () => ensureData()
      .then(() => isLatest() && needsData(hash) ? untilReady() : undefined);

    return untilReady().then(
      () => {
        hide();
        if (isLatest()) return go();
      },
      error => {
        hide();
        if (isLatest()) return fail(error);
      }
    );
  };
}
